module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_pc_d08cbd12d9182108ad1a8b1166e17ea7.png";